module.exports = __webpack_public_path__ + "img/e4d5b881-6835-45b7-8766-3e5b9e7cab8b.428f898.svg";